(function() {
    'use strict';
    angular
        .module('liverunApp')
        .factory('SocialMedia', SocialMedia);

    SocialMedia.$inject = ['$resource'];

    function SocialMedia ($resource) {
        var resourceUrl =  'api/social-medias/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
